import React, { useContext } from "react";
import { FieldProps } from "@rjsf/utils";
import { AuthContext } from "../../../../../../Authorization/AuthContext";
import { BuilderFieldWrapper } from "../../__styles__/SubmissionsBuilder";
import { SubmissionsBuilderContextInstance } from "../../context";
import { withStopPropagation } from "../../utils";
import FieldPreviewFooter from "./FieldPreviewFooter";

const BaseFieldPreview = (
  props: FieldProps & { widgetPreview: JSX.Element },
) => {
  const { fieldActionsPropsByPath, fieldContextsByName, selectedField } =
    useContext(SubmissionsBuilderContextInstance);
  const { account } = useContext(AuthContext);

  const id = props.idSchema.$id;

  const fieldContext = fieldContextsByName[id];

  if (!fieldContext) {
    return null;
  }

  const fieldProps = fieldActionsPropsByPath[fieldContext.fieldPath];

  if (!fieldProps) {
    return null;
  }

  const { selectField } = fieldProps;
  const isSelected = selectedField?.name === props.name;

  return (
    <BuilderFieldWrapper
      onClick={withStopPropagation(selectField)}
      isSelected={isSelected}
    >
      <div style={{ marginBottom: "4px" }}>
        {React.cloneElement(props.widgetPreview, { isSubmissionBuilder: true })}
      </div>
      <FieldPreviewFooter
        fieldPath={fieldContext.fieldPath}
        {...fieldProps}
        userGroups={account?.userGroups ?? []}
      />
    </BuilderFieldWrapper>
  );
};

export default BaseFieldPreview;
